import { Switch } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../contentConstants';
import { SwitchWithLabelContainer } from '../audience/SharedComponents';

export interface IEnableHtmlProps {
	enableHtmlContent?: boolean;
	getValue?: any;
}

export class EnableHtml extends React.Component<IEnableHtmlProps> {
	constructor(props: {}) {
		super(props);
	}

	public render() {
		const { enableHtmlContent, getValue } = this.props;
		return (
			<SwitchWithLabelContainer>
				<Switch checked={enableHtmlContent ? enableHtmlContent : false} getValue={getValue} /> <div>{ContentConstants.ENABLE_HTML}</div>
			</SwitchWithLabelContainer>
		);
	}
}
